module.exports = __webpack_public_path__ + "fonts/CosmopolitanScript-Regular.8089ffc5.woff2";